import { Grid, styled } from '@mui/material';

export const GridItem = styled(Grid, {
  shouldForwardProp: prop => prop !== 'item',
})`
  min-height: 120px;
  min-width: 120px;
  padding: 16px 24px;
`;
